import { z } from "zod";
import api, { getBackstageURL } from "services/api";

export const cityInfoUpdateDateSchema = z.object({
  cityDataUpdateDt: z.date(),
});

export type CityInfoUpdateDate = z.infer<typeof cityInfoUpdateDateSchema>;

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    cityInfoUpdateDate: build.query<CityInfoUpdateDate, void>({
      query: () => getBackstageURL("/city-info-update-date"),
      providesTags: ["CityInfoUpdateDate"],
    }),
    updateCityInfoUpdateDate: build.mutation<void, CityInfoUpdateDate>({
      query: (body) => ({
        url: getBackstageURL(`/city-info-update-date`),
        method: "PUT",
        body,
      }),
      invalidatesTags: ["CityInfoUpdateDate"],
    }),
    updateLandTradeData: build.mutation<void, void>({
      query: (body) => ({
        url: getBackstageURL(`/city-info-update-date/land-trade`),
        method: "POST",
        body,
      }),
    })
  }),
  overrideExisting: false,
});

export const {
  useCityInfoUpdateDateQuery,
  useUpdateCityInfoUpdateDateMutation,
  useUpdateLandTradeDataMutation,
} = extendedApi;
